<template>
    <div class="pe-viewer" v-if="viewerHtml !== null" v-html="viewerHtml">

    </div>
</template>

<script>
    export default {
        name: "pe",
        data: function () {
            return {
                state: '',
            }
        },
        computed: {
            isViewerOpen() {
                return this.$store.state.isViewerOpen
            },
            viewerHtml() {
                return this.$store.state.viewerHtml;
            },
            steps() {
                return this.$store.state.steps;
            },
            color() {

            },
            answers() {
                return this.$store.state.answers;
            },
        },
        watch: {
            answers() {
                this.launchPreviewUpdate();
            },
            povSwitch(val) {
                this.pov = val ? 'interior' : "exterior"
            }
        },

        mounted() {
            this.updatePreview();
        },

        methods: {

            togglePov(state) {
                if (this.pov === state) {
                    return
                }
                this.pov = state;
            },

            updatePreview() {
                let $this = this;
                let runs = 3;
                let i = setInterval(function () {
                    if ($('.front').length > 0 && $('.back').length > 0) {
                        setTimeout(() => {
                            $this.launchPreviewUpdate()
                        }, 500);
                        clearInterval(i)
                    }
                }, 100);
            },
            launchPreviewUpdate() {
                Object.keys(this.answers).forEach((stepKey) => {
                    Object.keys(this.answers[stepKey]).forEach((questionKey) => {
                        Object.keys(this.answers[stepKey][questionKey]).forEach((answerKey) => {
                            this.updatePreviewForAnswer(this.answers[stepKey][questionKey][answerKey])
                        });
                    });
                });
            },
            updatePreviewForAnswer(answer) {
                if (!answer || !answer.effectOnSvg || answer.effectOnSvg === 'none') {
                    return;
                }

                this.state = answer.effectOnSvg;
                let door = $('.door');
                switch (this.state) {
                    case "change-sens" :
                        let backgroundUrl = door.css('background-image');
                        if (answer.value === 1) {
                            door.css({
                                "background-image": backgroundUrl.replace("d.png", "g.png")
                            })
                        } else {
                            door.css({
                                "background-image": backgroundUrl.replace("g.png", "d.png")
                            })
                        }
                        break;
                    case "change-coloris" :
                        if (answer.photo_url) {
                            door.css({
                                "background-image": `url("${answer.photo_url}")`
                            })
                        }
                }
                this.$forceUpdate();
            },
        }
    }
</script>


<style>

    .pe-viewer {
        height: 100%;
        width: 90%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .door {
        height: 100%;
        min-height: 180px;

        width: 60%;

        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
    }

</style>
